export const SET_NOTIFICATION_COUNT = 'SET_NOTIFICATION_COUNT';
export const setNotificationCount = (count) => {
  return async (dispatch) => dispatch({ type: SET_NOTIFICATION_COUNT, payload: { count } });
} 